/**
 * token_key
 */
let tokenKey = 'ql_token'


export function saveToken(token) {
    localStorage.setItem(tokenKey, token)
}

export function getToken() {
    let token = localStorage.getItem(tokenKey)
    if (token) {
        return token
    }

    return null
}

export function removerToken() {
    return localStorage.removeItem(tokenKey)
}


